import React, { useEffect, useState } from 'react';
import styles from './TenantAutoInfoFields.module.scss';
import useTransportCountries from '../../../../../../queries/useTransportCountries';
import { Form, Input, Select } from 'antd';

const { Option } = Select;

export const TenantAutoInfoFields = ({ form, autoInfo = {}, isCanEdit }) => {
  const { data: countries, isFetching: isCountriesFetching } =
    useTransportCountries({ staleTime: Infinity });

  const [transportCountries, setTransportCountries] = useState([]);

  const [formData, setFormData] = useState({
    country: autoInfo?.country?.id || '',
    number: autoInfo?.number || '',
    region: autoInfo?.region || '',
    model: autoInfo?.model || '',
    brand: autoInfo?.brand || '',
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAutoNumberChange = (e) => {
    const rawValue = e.target.value
      .toUpperCase()
      .replace(/[^АВЕКМНОРСТУХD0-9]/g, '');

    setFormData((prev) => ({
      ...prev,
      number: rawValue,
    }));

    form.setFieldsValue({ number: rawValue });
  };

  const handleRegionCodeChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '');

    setFormData((prev) => ({
      ...prev,
      region: rawValue,
    }));
  };

  useEffect(() => {
    if (countries?.length) {
      setTransportCountries(countries);
    }
  }, [countries]);

  return (
    <div className={styles.root}>
      {isCanEdit ? (
        <div className={styles.formFields}>
          <Form.Item label="Страна">
            {form.getFieldDecorator('country', {
              initialValue: formData.country || transportCountries[0]?.id,
              rules: [{ required: true, message: 'Страна не выбрана' }],
            })(
              <Select
                placeholder="Россия"
                className={styles.select}
                onChange={(value) => handleChange('country', value)}
                loading={isCountriesFetching}
              >
                {transportCountries.map((item) => (
                  <Option
                    key={item.id}
                    value={item.id}
                  >
                    {item.name}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
          <div className={styles.dualAutoFields}>
            <Form.Item label="Номер автомобиля">
              {form.getFieldDecorator('number', {
                initialValue: formData.number,
                rules: [
                  {
                    required: true,
                    message: 'Номер не указан',
                  },
                  {
                    pattern: /^[АВЕКМНОРСТУХD]{1}\d{3}[АВЕКМНОРСТУХD]{2}$/,
                    message: 'Номер должен быть в формате: А123ВЕ',
                  },
                ],
                normalize: (value = '') =>
                  value.toUpperCase().replace(/[^АВЕКМНОРСТУХD0-9]/g, ''),
              })(
                <Input
                  type="text"
                  placeholder="А123ВЕ"
                  onChange={handleAutoNumberChange}
                  maxLength={6}
                  autoComplete="off"
                  spellCheck={false}
                />
              )}
            </Form.Item>
            <Form.Item label="Регион">
              {form.getFieldDecorator('region', {
                initialValue: formData.region,
                rules: [
                  { required: true, message: 'Регион не указан' },
                  {
                    pattern: /^[0-9]{2,3}$/,
                    message: 'Регион должен быть в формате: 197',
                  },
                ],
              })(
                <Input
                  type="text"
                  placeholder="197"
                  onChange={handleRegionCodeChange}
                  maxLength={3}
                />
              )}
            </Form.Item>
          </div>
          <Form.Item label="Марка">
            {form.getFieldDecorator('brand', {
              initialValue: formData.brand,
              rules: [{ required: true, message: 'Марка не указана' }],
            })(
              <Input
                type="text"
                placeholder="BMW"
                onChange={(e) => handleChange('brand', e.target.value)}
              />
            )}
          </Form.Item>
          <Form.Item label="Модель">
            {form.getFieldDecorator('model', {
              initialValue: formData.model,
              rules: [{ required: true, message: 'Модель не указана' }],
            })(
              <Input
                type="text"
                placeholder="X5 2019"
                onChange={(e) => handleChange('model', e.target.value)}
              />
            )}
          </Form.Item>
        </div>
      ) : (
        <>
          <span className={styles.autoInfo}>{autoInfo?.country?.name}</span>
          <span className={styles.autoInfo}>{autoInfo?.number}</span>
          <span className={styles.autoInfo}>{autoInfo?.region}</span>
          <span className={styles.autoInfo}>{autoInfo?.brand}</span>
          <span className={styles.autoInfo}>{autoInfo?.model}</span>
        </>
      )}
    </div>
  );
};
